import { useState } from "react";

import { DialogViewContainer } from "@/features/common/components/DialogViewContainer";
import { Tabs } from "@/features/common/components/Tabs";
import { DebouncedSearchInput } from "@/features/common/components/filter/DebouncedSearchInput";
import { InviteModelForm } from "@/features/job/components/manage/ModelInvitationDialogView/InviteModelForm";
import { InviteModelList } from "@/features/job/components/manage/ModelInvitationDialogView/InviteModelList";
import { useGenderTabs } from "@/features/job/hooks/useGenderTabs";
import {
  GenderEnum,
  Job,
  useModelGendersCountQuery,
} from "@/generated/graphql-hooks";

export type ModelInvitationDialogViewProps = {
  job: Job;
};

export const ModelInvitationDialogView = (
  { job }: ModelInvitationDialogViewProps,
) => {
  const { data: { femaleModelsCount, maleModelsCount } = {} } =
    useModelGendersCountQuery({
      where: {
        jobApplications: {
          none: {
            jobId: { equals: job.id },
          },
        },
      },
    });

  const { tabs, currentTab, setCurrentTab } = useGenderTabs({
    femaleCount: femaleModelsCount,
    maleCount: maleModelsCount,
  });

  const [debouncedSearchInput, setDebouncedSearchInput] = useState("");

  return (
    <DialogViewContainer
      className="!flex-none !pb-0"
      title={
        <div className="space-x-3">
          <span>選擇你想邀請的KOL</span>
          <span className="text-sm text-gray-500">*最多可邀請10位</span>
        </div>
      }
      outerChildren={
        <InviteModelForm
          jobId={job.id}
          invitationsCount={job.invitationsCount}
          tab={currentTab}
        >
          <DebouncedSearchInput
            onDebouncedInputChange={setDebouncedSearchInput}
          />
          <InviteModelList
            count={
              currentTab === GenderEnum.Female
                ? femaleModelsCount
                : maleModelsCount
            }
            job={job}
            gender={currentTab}
            searchInput={debouncedSearchInput}
          />
        </InviteModelForm>
      }
    >
      <div className="-mx-6 border-b border-gray-200 sm:mx-0">
        <Tabs
          currentTab={currentTab}
          tabs={tabs}
          onSelect={(tab: GenderEnum) => setCurrentTab(tab)}
          isFullWidth
        />
      </div>
    </DialogViewContainer>
  );
};
